<template>
    <div>
        <v-snackbar 
            color="primary"
            v-model="user.passwordSuccess">
            Wachtwoord succesvol aangepast
            <v-btn
                color="primary"
                text
                @click="user.passwordSuccess = false">
                <v-icon small color="white" >mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        
        <v-snackbar 
            color="error"
            v-model="user.passwordError">
            Fout in huidig wachtwoord
            <v-btn
                text
                @click="user.passwordError = false">
                <v-icon small color="white">mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"])
  }
};
</script>
